export const API_URL = process.env.REACT_APP_API_ENDPOINT;
export const API_DEPARTAMENTOS_URL = `${API_URL}/departamentos`;
export const API_MATERIAS_URL = `${API_URL}/departamento`;
export const API_LAST_UPDATE = `${API_URL}/last_update`;
export const API_HORARIOS_URL = `${API_URL}/materia`;